import { createBrowserRouter } from "react-router-dom";
// import Home from "../pages/home";
import SubscriberHome from "../pages/subscriber-home";
import Register from "../pages/auth/register";
import Login from "../pages/auth/login";
import Main from "../pages/main";
import Overview from "../pages/overview";
import Appointments from "../pages/appointments";
import Prescription from "../pages/prescriptions";
import Diagnostics from "../pages/diagnostics";
import Profile from "../pages/profile";
import PickAPlan from "../pages/plans/pick-a-plan";
import AuthRoutes from "./auth.routes";
import Ordering from "../pages/prescriptions/ordering";
import Booking from "../pages/appointments/booking";
import Chat from "../pages/chime/chat";
import KobikuulChat from "../pages/chat";
import KobikuulCampaign from "../pages/kobikuul";
import Play from "../pages/play";
import WeaveSpike from "../pages/play/weave-spike";
import KaeKente from "../pages/play/kae-kente";
import Leaderboard from "../pages/play/leaderboard";
import DoseSpike from "../pages/play/dose-spike";
import DoseDash from "../pages/play/dose-dash";
import Makola from "../pages/play/makola";
import Details from "../pages/appointments/details";
import Claims from "../pages/claims";
import Request from "../pages/claims/request";
import Cancel from "../pages/appointments/cancel";
import Reschedule from "../pages/appointments/reschedule";
import AllAppointments from "../pages/appointments/all-appointments";
import Billing from "../pages/plans/billing";
import Unsubscribe from "../pages/plans/unsubscribe";
import ConfirmPayment from "../pages/plans/confirm-payment";
import DoctorReport from "../pages/appointments/doctor-report";
import NotFound from "../pages/not-found";
import FAQ from "../pages/faq";
import Termsandconditions from "../pages/terms-and-conditions/termsandconditions";
import ForgotPassword from "../pages/auth/forgot-password";
import OAuthSuccess from "../pages/auth/oauth-success";
import OAuthError from "../pages/auth/oauth-error";
import Contact from "../components/sections/contact";
import Selectmcareplan from "../pages/plans/select-mcare-plan";
import Mcarebilling from "../pages/plans/mcare-billing";
import ConfirmMcarePayment from "../pages/plans/confirm-mcarepayment";
import HomeOne from "../pages/landing-pages/home-one";
import HomeTwo from "../pages/landing-pages/home-two";
import Packages from "../pages/packages/packages";
import ActiveWithYelloCare from "../pages/auth/active-with-yellocare";
// import NewHome from "../pages/home1/new-home";
// import Infomedic from "../pages/infomedic";
// import InfoRequest from "../pages/infomedic/request";

export const router = createBrowserRouter([
  {
    path: "*",
    element: <NotFound />,
  },
  // {
  //   element: <Home />,
  //   path: "/",
  // },
  {
    element: <HomeOne />,
    path: "/one",
  },
  {
    element: <HomeTwo />,
    path: "/",
  },
  {
    element: <SubscriberHome />,
    path: "/sub",
  },
  {
    // MTN Pulse/Prestige campaign landing chat (anonymous — the SMS links
    // point here with ?source=pulse|prestige).
    element: <KobikuulCampaign />,
    path: "/kobikuul",
  },
  {
    // Games hub — public, no auth, reached from the homepage promo deck.
    element: <Play />,
    path: "/play",
  },
  {
    element: <KaeKente />,
    path: "/play/kae-kente",
  },
  {
    element: <DoseDash />,
    path: "/play/dose-dash",
  },
  {
    element: <Makola />,
    path: "/play/makola",
  },
  {
    element: <Leaderboard />,
    path: "/play/leaderboard",
  },
  {
    // Throwaway spike for the Kente weave animation — not linked from the
    // hub, and not the game.
    element: <WeaveSpike />,
    path: "/play/weave-spike",
  },
  {
    // Same for Dose Dash's day cycle.
    element: <DoseSpike />,
    path: "/play/dose-spike",
  },
  {
    element: <FAQ />,
    path: "/faq",
  },
  {
    element: <Contact />,
    path: "/contact-us",
  },
  {
    element: <Termsandconditions />,
    path: "/terms",
  },
  {
    element: <Packages />,
    path: "/packages",
  },
  {
    element: <ForgotPassword />,
    path: "/forgot-password",
  },
  {
    path: "/sign-in",
    element: <Login />,
  },
  {
    path: "/auth/success",
    element: <OAuthSuccess />,
  },
  {
    path: "/auth/error",
    element: <OAuthError />,
  },
  {
    path: "/sign-up",
    element: <Register />,
  },
  {
    element: <AuthRoutes />,
    children: [
      {
        path: "/activate-with-yellocare",
        element: <ActiveWithYelloCare />,
      },
      {
        path: "/pick-plan",
        element: <PickAPlan />,
      },
      {
        path: "/plan/billing/:id",
        element: <Billing />,
      },

      {
        path: "/plan/comfirm-pay-00725",
        element: <ConfirmPayment />,
      },
      {
        path: "/main",
        element: <Main />,
        children: [
          {
            element: <Overview />,
            index: true,
          },
          {
            path: "/main/appointments",
            element: <Appointments />,
          },
          {
            path: "/main/claims",
            element: <Claims />,
          },
          {
            path: "/main/claims/request",
            element: <Request />,
          },
          {
            path: "/main/appointments/booking",
            element: <Booking />,
          },
          {
            path: "/main/appointments/all",
            element: <AllAppointments />,
          },
          {
            path: "/main/appointments/:id",
            element: <Details />,
          },
          {
            path: "/main/appointments/:id/report",
            element: <DoctorReport />,
          },
          {
            path: "/main/plans",
            element: <Selectmcareplan />,
          },
          {
            path: "/main/billing/:id",
            element: <Mcarebilling />,
          },
          {
            path: "/main/plan/mcare-comfirm-pay-00725",
            element: <ConfirmMcarePayment />,
          },
          {
            path: "/main/appointments/reschedule/:id",
            element: <Reschedule />,
          },
          {
            path: "/main/appointments/cancel/:id",
            element: <Cancel />,
          },
          {
            path: "/main/appointments/chat",
            element: <Chat />,
          },
          {
            path: "/main/chat",
            element: <KobikuulChat />,
          },
          {
            path: "/main/prescriptions",
            element: <Prescription />,
          },
          {
            path: "/main/prescriptions/ordering",
            element: <Ordering />,
          },
          {
            path: "/main/diagnostics",
            element: <Diagnostics />,
          },
          {
            path: "/main/profile/:id",
            element: <Profile />,
          },
          {
            path: "/main/unsubscribe",
            element: <Unsubscribe />,
          },
          // {
          //   path: "/main/infomedic",
          //   element: <Infomedic />,
          // },
          // {
          //   path: "/main/infomedic/:id",
          //   element: <InfoRequest />,
          // },
        ],
      },
    ],
  },
]);
